import React from 'react';
import ABResultPage from '../pages/result/ABResultPage';

const ABResultProvider = (props: any) => {
    const { params } = props.match;
    return (
        <React.Fragment>
            <ABResultPage testId={params?.id} />
        </React.Fragment>
    );
}

export default ABResultProvider;